import script from "./BaseDataComponent.vue?vue&type=script&lang=js"
export * from "./BaseDataComponent.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__